import { useLingui } from '@lingui/react/macro'

import * as Form from '@/features/form'
import Title from './Title'
import InputTile from './InputTile'
import { MultipleButtonRowInput } from '@/features/buttonRow'

export default function ButtonRows() {
  const { t } = useLingui()

  return (
    <InputTile>
      <Title
        title={t`Button Rows`}
        description={t`Add rows of custom buttons that are shown to the guest in his profile view.`}
      />
      <Form.Field name="buttonRows">
        {({ renderProps }) => <MultipleButtonRowInput {...renderProps} />}
      </Form.Field>
    </InputTile>
  )
}
